import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamsObj } from 'src/app/core/utils/type-util';
import { MEMBER_ID_LABEL } from '../constants/mapping-keys';
import { JSONResponse } from '../models/json-response';
import { OrganizationMappingKeys } from '../models/mapping-keys';
import { Organization } from '../models/organization';
import { AuthService } from './auth.service';

const getUserOrganizationsUrl = '/organizations/getUserOrganizations.html';
const getOrganizationsUrl = '/organizations/getOrganizations.html';
const getMappingKeysUrl = '/organizations/getMappingKeys.html';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getUserOrganizations(userId?: number): Observable<Organization[]> {
    let params: HttpParamsObj;

    if (userId) {
      params = {
        userId: userId
      };
    }

    return this.http.get<Organization[]>(getUserOrganizationsUrl, {
      params: params
    });
  }

  getOrganizations(orgId?: number): Observable<Organization[]> {
    return this.http.get<Organization[]>(getOrganizationsUrl, {
      params: {
        orgId: orgId || 0
      }
    });
  }

  getMappingKeys(mappingKey: string, orgId = 0, orgLevel = 0): Observable<OrganizationMappingKeys[]> {
    return this.http
      .post<JSONResponse<OrganizationMappingKeys[]>>(getMappingKeysUrl, '', {
        params: {
          mappingkey: mappingKey,
          orgId: orgId,
          orgLevel: orgLevel
        }
      })
      .pipe(map((response) => response.result));
  }

  getCachedMappingKey(key: string): string {
    const mappingKeyValue = this.authService.mappingKeys && this.authService.mappingKeys[key];

    if (mappingKeyValue == null) {
      console.warn(
        `${key} mapping key not configured [orgId=${this.authService.orgId}, orgLevel=${this.authService.orgLevel}]`
      );
    }

    return mappingKeyValue;
  }

  getMemberIdLabelMappingKey(): string {
    return this.getCachedMappingKey(MEMBER_ID_LABEL) || 'Member ID';
  }
}
